import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class QuarryFlooded4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.QUARRY_FLOODED4;
}

export default QuarryFlooded4PoiTileEntity;
